import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { deactivateZendeskSatisfactionRatingBackwardSync } from 'actions'

import SatisfactionRatingBackwardSyncSettingPresentation from 'components/Admin/Surveys/ZendeskIntegrationSettings/SatisfactionRatingBackwardSyncSetting'

class SatisfactionRatingBackwardSyncSetting extends React.Component {
  onClickDeactivate = (event) => {
    event.preventDefault()
    this.props.deactivateZendeskSatisfactionRatingBackwardSync()
  }

  render() {
    return (
      <SatisfactionRatingBackwardSyncSettingPresentation
        onClickDeactivate={this.onClickDeactivate}
      />
    )
  }
}

SatisfactionRatingBackwardSyncSetting.propTypes = {
  deactivateZendeskSatisfactionRatingBackwardSync: PropTypes.func.isRequired,
}

const mapDispatch = (dispatch, { surveyId }) => ({
  deactivateZendeskSatisfactionRatingBackwardSync: () =>
    dispatch(deactivateZendeskSatisfactionRatingBackwardSync(surveyId)),
})

export default connect(null, mapDispatch)(SatisfactionRatingBackwardSyncSetting)



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/Admin/Surveys/ZendeskIntegrationSettings/SatisfactionRatingBackwardSyncSetting.js